import { DotScreenEffect } from 'postprocessing'
import { wrapEffect } from '../util'

export const DotScreen = wrapEffect(DotScreenEffect)
